/* ==========================================================================
   Ergomi — theme.js
   Core interactivity, no animation libraries. Runs on EVERY device.
   Handles: scroll-reveal (IntersectionObserver), header, mobile nav,
   accordions, cart drawer, add-to-cart (AJAX), add-to-cart upsell popup
   (Shopify product recommendations), sticky ATC, gallery, variants, email popup.
   ========================================================================== */
(function () {
  'use strict';
  var H = window.Ergomi || { routes: {}, strings: {} };
  var ROOT = (H.routes && H.routes.root) ? H.routes.root : '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/'; // '/en' -> '/en/'
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  document.documentElement.classList.add('js');

  /* Scroll lock derived from ACTUAL open overlays (no fragile counter).
     Body scroll is frozen only while at least one overlay is open, and is
     always released once they're all closed — immune to open/close ordering. */
  function updateScrollLock() {
    var anyOpen = document.querySelector('.cart-drawer.is-open, .mobile-menu.is-open, .upsell-popup.is-open, .filter-drawer.is-open');
    document.body.style.overflow = anyOpen ? 'hidden' : '';
  }

  var fmt = null;
  function money(cents) {
    var amount = cents / 100;
    try {
      if (!fmt) fmt = new Intl.NumberFormat((H.locale || document.documentElement.lang || 'sv-SE'), {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK',
        maximumFractionDigits: 0
      });
      return fmt.format(amount);
    } catch (e) { return Math.round(amount) + ' kr'; }
  }

  /* ============================================================
     SHARED: modern custom dropdown + colour swatches
     Used by the multi-buy bundle AND the standard product page.
     ============================================================ */
  var ERGOMI_SW = [
    ['svart','#1b1b1b'],['black','#1b1b1b'],['vit','#f1f1f1'],['white','#f1f1f1'],
    ['mörkgrå','#3d3d3d'],['morkgra','#3d3d3d'],['grafit','#3d3d3d'],['dark grey','#3d3d3d'],['dark gray','#3d3d3d'],
    ['kungsblå','#2a4bd7'],['kungsbla','#2a4bd7'],['royal','#2a4bd7'],['marin','#1b2a4a'],['navy','#1b2a4a'],
    ['vinröd','#6e1b2e'],['vinrod','#6e1b2e'],['bordeaux','#6e1b2e'],['wine','#6e1b2e'],
    ['knallrosa','#ff4fa3'],['bright pink','#ff4fa3'],['lavendel','#b9a6d4'],['lavender','#b9a6d4'],
    ['påfågel','#1a8c7a'],['pafagel','#1a8c7a'],['peacock','#1a8c7a'],['petrol','#1a8c7a'],
    ['kaffe','#6f4e37'],['coffee','#6f4e37'],['brun','#6f4e37'],['brown','#6f4e37'],['champagne','#e6d5b8'],
    ['aprikos','#e8c9a0'],['apricot','#e8c9a0'],['beige','#d9c2a6'],['nude','#d9c2a6'],['sand','#d9c2a6'],
    ['oliv','#6b6b3a'],['olive','#6b6b3a'],['khaki','#8f8b5a'],['turkos','#1aa7a0'],['teal','#1aa7a0'],
    ['orangeröd','#e2552b'],['orange','#e2552b'],['korall','#f0734e'],['coral','#f0734e'],
    ['melerad','#9a9a9a'],['heather','#9a9a9a'],['plommon','#7a3fa0'],['lila','#7a3fa0'],['purple','#7a3fa0'],
    ['rosa','#f2a1c0'],['pink','#f2a1c0'],['grå','#9a9a9a'],['gra','#9a9a9a'],['grey','#9a9a9a'],['gray','#9a9a9a'],
    ['röd','#c0392b'],['rod','#c0392b'],['red','#c0392b'],['grön','#3fa34d'],['gron','#3fa34d'],['green','#3fa34d'],
    ['blå','#2a6fdb'],['bla','#2a6fdb'],['blue','#2a6fdb'],['gul','#e8c33a'],['yellow','#e8c33a']
  ];
  function swatchFor(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('batik') > -1 || n.indexOf('tie') > -1 || n.indexOf('dye') > -1) {
      if (n.indexOf('blå') > -1 || n.indexOf('bla') > -1 || n.indexOf('blue') > -1) return 'conic-gradient(#2a6fdb,#7a3fa0,#1aa7a0,#2a6fdb)';
      return 'conic-gradient(#7a3fa0,#ff4fa3,#2a6fdb,#7a3fa0)';
    }
    for (var i = 0; i < ERGOMI_SW.length; i++) { if (n.indexOf(ERGOMI_SW[i][0]) > -1) return ERGOMI_SW[i][1]; }
    return '#cfcabf';
  }
  // colorImg: { colourValue: imageUrl }. Builds the dropdown over a native <select>.
  function buildCustomSelect(sel, colorImg) {
    colorImg = colorImg || {};
    var isColor = sel.hasAttribute('data-color');
    var wrap = document.createElement('div');
    wrap.className = 'cselect' + (isColor ? ' cselect--color' : '') + (sel.classList.contains('bundle__select--size') ? ' cselect--size' : '');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'cselect__btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var menu = document.createElement('div'); menu.className = 'cselect__menu'; menu.setAttribute('role', 'listbox'); menu.hidden = true;
    function sw(name) {
      if (!isColor) return '';
      if (colorImg[name]) return '<i class="cselect__sw cselect__sw--img" style="background-image:url(' + colorImg[name] + ')"></i>';
      return '<i class="cselect__sw" style="background:' + swatchFor(name) + '"></i>';
    }
    function close() { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); }
    function setVal(val) {
      sel.value = val;
      btn.innerHTML = '<span class="cselect__cur">' + sw(val) + '<span>' + val + '</span></span><span class="cselect__caret"></span>';
      Array.prototype.forEach.call(menu.querySelectorAll('.cselect__opt'), function (o) { o.setAttribute('aria-selected', o.getAttribute('data-value') === val ? 'true' : 'false'); });
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    Array.prototype.forEach.call(sel.options, function (opt) {
      var o = document.createElement('div'); o.className = 'cselect__opt'; o.setAttribute('role', 'option'); o.setAttribute('data-value', opt.value);
      o.innerHTML = sw(opt.value) + '<span>' + opt.textContent + '</span>';
      o.addEventListener('click', function () { setVal(opt.value); close(); });
      menu.appendChild(o);
    });
    btn.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) { menu.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); } else close(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    wrap.appendChild(btn); wrap.appendChild(menu);
    sel.style.display = 'none';
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    setVal(sel.value || (sel.options[0] && sel.options[0].value) || '');
  }
  // Build a { colourValue: thumbUrl } / { colourValue: imagePosition } map from a product's variants.
  function colourImageMaps(product, colorPos) {
    var img = {}, pos = {};
    if (colorPos) {
      product.variants.forEach(function (vr) {
        var cv = vr.options[colorPos - 1];
        if (cv && !img[cv] && vr.featured_image && vr.featured_image.src) {
          var s = vr.featured_image.src;
          img[cv] = s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=80&height=80&crop=center';
          pos[cv] = vr.featured_image.position;
        }
      });
    }
    return { img: img, pos: pos };
  }

  /* ============================================================
     1. SCROLL REVEAL — dependency-free, works on mobile + desktop
     ============================================================ */
  (function () {
    var items = document.querySelectorAll('.reveal-item');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // gentle stagger based on position among siblings
          var siblings = el.parentElement ? el.parentElement.querySelectorAll('.reveal-item') : [el];
          var idx = Array.prototype.indexOf.call(siblings, el);
          el.style.transitionDelay = Math.min(idx, 6) * 70 + 'ms';
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: reveal anything still hidden after 2.5s (e.g. zero-height edge cases)
    setTimeout(function () {
      document.querySelectorAll('.reveal-item:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight + 200) el.classList.add('is-visible');
      });
    }, 2500);
  })();

  /* ============================================================
     2. HEADER + MOBILE NAV
     ============================================================ */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuOverlay = document.querySelector('.mobile-menu__overlay');
  var menuToggles = document.querySelectorAll('[data-menu-open]');
  function setToggleState(on) {
    menuToggles.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (menuOverlay) menuOverlay.classList.add('is-active');
    mobileMenu.setAttribute('aria-hidden', 'false');
    setToggleState(true);
    updateScrollLock();
  }
  function closeNav() {
    if (!mobileMenu) return;
    if (!mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    if (menuOverlay) menuOverlay.classList.remove('is-active');
    mobileMenu.setAttribute('aria-hidden', 'true');
    setToggleState(false);
    updateScrollLock();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeNav(); return; }
  });
  // Close the menu when a navigation link inside it is followed
  if (mobileMenu) {
    mobileMenu.querySelectorAll('.mobile-menu__nav a').forEach(function (a) {
      a.addEventListener('click', function () { closeNav(); });
    });
  }

  /* ============================================================
     3. ACCORDIONS — fast, smooth slide open/close
     ============================================================ */
  function accSlide(el, open) {
    if (reduced) { el.hidden = !open; return; }
    if (open) el.hidden = false;
    el.style.overflow = 'hidden';
    el.style.maxHeight = open ? '0px' : el.scrollHeight + 'px';
    el.style.opacity = open ? '0' : '1';
    el.style.transition = 'max-height ' + (open ? '.28s' : '.22s') + ' cubic-bezier(.4,0,.2,1), opacity .2s ease';
    requestAnimationFrame(function () {
      el.style.maxHeight = open ? el.scrollHeight + 'px' : '0px';
      el.style.opacity = open ? '1' : '0';
    });
    el.addEventListener('transitionend', function te(e) {
      if (e.propertyName !== 'max-height') return;
      if (!open) el.hidden = true;
      el.style.maxHeight = ''; el.style.overflow = ''; el.style.transition = ''; el.style.opacity = '';
      el.removeEventListener('transitionend', te);
    });
  }
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var body = btn.nextElementSibling;
      if (body) accSlide(body, !expanded);
    });
  });

  /* ============================================================
     4. CART DRAWER
     ============================================================ */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-overlay');

  function openCart() {
    if (!drawer) return;
    closeNav();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    updateScrollLock();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
    updateScrollLock();
  }
  window.ErgomiOpenCart = openCart;
  window.ErgomiAddToCart = addToCart;

  // Event delegation so dynamically-added triggers work too
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openCart(); fetchCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeUpsell(); closeNav(); }
  });

  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (!drawer) return;
    var itemsEl = drawer.querySelector('.cart-drawer__items');
    var footEl = drawer.querySelector('.cart-drawer__foot');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">' + (H.strings.cartEmpty || 'Din varukorg är tom') + '</div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(_(\d+)x(\d+))?(\.[^.?]*)(\?.*)?$/, '_120x$4') : '';
      html += '<div class="cart-line" data-key="' + item.key + '">' +
        (img ? '<img src="' + img + '" alt="" width="64" height="80" loading="lazy">' : '<span></span>') +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '') +
        (item.properties ? Object.keys(item.properties).map(function (k) {
          return item.properties[k] ? '<div class="cart-line__variant">' + k + ': ' + item.properties[k] + '</div>' : '';
        }).join('') : '') +
        (item.line_level_discount_allocations && item.line_level_discount_allocations.length ? item.line_level_discount_allocations.map(function (a) {
          return '<div class="cart-line__deal">' + ((a.discount_application && a.discount_application.title) || '') + ' <b>−' + money(a.amount) + '</b></div>';
        }).join('') : '') +
        '<div class="cart-line__qty"><button data-qty-down aria-label="' + (H.strings.decrease || 'Minska') + '">−</button>' +
        '<span>' + item.quantity + '</span><button data-qty-up aria-label="' + (H.strings.increase || 'Öka') + '">+</button></div></div>' +
        '<div><div class="cart-line__price">' + money(item.final_line_price) + '</div>' +
        '<button class="cart-line__remove" data-remove>' + (H.strings.remove || 'Ta bort') + '</button></div></div>';
    });
    itemsEl.innerHTML = html;

    var threshold = (H.freeShipThreshold && H.freeShipThreshold > 0) ? H.freeShipThreshold : 39900; // free shipping across the whole site
    var bar = drawer.querySelector('.cart-ship-bar i');
    var note = drawer.querySelector('.cart-ship-note');
    if (bar) {
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      bar.style.width = pct + '%';
      if (note) {
        var left = money(threshold - cart.total_price);   // exact kr remaining
        // Ship-bar message ladder: translated templates from window.Ergomi.strings
        // ([left] = amount remaining, [amount] = the free-shipping threshold)
        var SS = H.strings || {};
        function shipT(key, fallback) { return (SS[key] || fallback).replace('[left]', left).replace('[amount]', money(threshold)); }
        var msg;
        if (cart.total_price >= threshold)  msg = shipT('ship100', 'Du har fri frakt — snyggt!');
        else if (cart.total_price === 0)    msg = shipT('ship0', 'Fri frakt över [amount]');
        else if (pct >= 95)                 msg = shipT('ship95', 'Nästan framme! Bara [left] kvar till fri frakt');
        else if (pct >= 88)                 msg = shipT('ship88', 'Sista kronorna — [left] kvar till fri frakt');
        else if (pct >= 78)                 msg = shipT('ship78', 'Så nära nu! [left] kvar till fri frakt');
        else if (pct >= 68)                 msg = shipT('ship68', 'Nästan där — [left] kvar till fri frakt');
        else if (pct >= 58)                 msg = shipT('ship58', 'Det börjar likna något! [left] kvar till fri frakt');
        else if (pct >= 48)                 msg = shipT('ship48', 'Halvvägs till fri frakt — [left] kvar');
        else if (pct >= 38)                 msg = shipT('ship38', 'Bra fart! [left] kvar till fri frakt');
        else if (pct >= 28)                 msg = shipT('ship28', 'Du är på väg — [left] kvar till fri frakt');
        else if (pct >= 15)                 msg = shipT('ship15', 'Bra start! [left] kvar så bjuder vi på frakten');
        else                                msg = shipT('shipStart', 'Lägg till [left] till så bjuder vi på frakten');
        note.innerHTML = msg;
      }
    }
    var totalEl = drawer.querySelector('.cart-total span:last-child');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  // Delegated qty / remove inside drawer
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      if (e.target.closest('[data-qty-up]')) changeQty(key, qty + 1);
      else if (e.target.closest('[data-qty-down]')) changeQty(key, qty - 1);
      else if (e.target.closest('[data-remove]')) changeQty(key, 0);
    });
  }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function changeQty(key, quantity) {
    fetch((H.routes.cart_change_url || ROOT + 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* ============================================================
     5. ADD TO CART (AJAX) — delegated, covers dynamic forms
     ============================================================ */
  function addToCart(items, btn, opts) {
    opts = opts || {};
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>…</span>'; }
    return fetch((H.routes.cart_add_url || ROOT + 'cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) btn.innerHTML = '<span>' + (H.strings.addedToCart || 'Tillagd') + '</span>';
        if (window.fbq) try { window.fbq('track', 'AddToCart'); } catch (e) {}
        return fetchCart().then(function () {
          var pid = null;
          if (data && data.items && data.items[0]) pid = data.items[0].product_id;
          else if (data && data.product_id) pid = data.product_id;
          if (opts.showUpsell !== false && pid) { showUpsell(pid); }
          else if (opts.openCartAfter !== false) { openCart(); }
          // adding from inside the upsell popup => openCartAfter:false => keep popup,
          // just refresh the count (avoids stacking the cart over the popup)
        });
      })
      .catch(function () {})
      .then(function () {
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          // restoring innerHTML replaces child nodes (e.g. the bundle price span) —
          // let listeners re-sync their references/text
          try { document.dispatchEvent(new Event('ergomi:atcRestored')); } catch (err) {}
        }, 1400);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var fromUpsell = !!form.closest('[data-upsell-popup]');
    addToCart([{ id: parseInt(id.value, 10), quantity: qty }], form.querySelector('[type="submit"]'),
      { showUpsell: !fromUpsell, openCartAfter: !fromUpsell });
  });

  // Frequently-bought-together button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fbt-add]');
    if (!btn) return;
    var form = btn.closest('[data-fbt-form]');
    if (!form) return;
    var items = [];
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      if (cb.value) items.push({ id: parseInt(cb.value, 10), quantity: 1 });
    });
    if (items.length) addToCart(items, btn, { showUpsell: true });
  });

  /* ============================================================
     6. ADD-TO-CART UPSELL POPUP — Shopify recommendations
     ============================================================ */
  var upsell = document.querySelector('[data-upsell-popup]');
  function closeUpsell() {
    if (!upsell) return;
    upsell.classList.remove('is-open');
    updateScrollLock();
  }
  if (upsell) {
    upsell.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-close]')) closeUpsell();
      if (e.target.closest('[data-upsell-cart]')) { closeUpsell(); openCart(); }
    });
  }
  function showUpsell(productId) {
    if (!upsell) { openCart(); return; }
    // Kurerade merförsäljningsrutor (valda i temainställningarna) → öppna direkt
    if (upsell.hasAttribute('data-upsell-curated')) {
      upsell.classList.add('is-open');
      updateScrollLock();
      return;
    }
    var listEl = upsell.querySelector('[data-upsell-items]');
    var url = ROOT + 'recommendations/products?section_id=product-recommendations&limit=4&intent=related&product_id=' + productId;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var tmp = document.createElement('div');
        tmp.innerHTML = txt;
        var found = tmp.querySelector('[data-rec-list]');
        if (found && found.children.length > 0) {
          listEl.innerHTML = found.innerHTML;
          upsell.classList.add('is-open');
          updateScrollLock();
        } else {
          openCart(); // no recommendations → just show the cart
        }
      })
      .catch(function () { openCart(); });
  }

  /* ============================================================
     7. STICKY MOBILE ATC
     ============================================================ */
  var mainAtc = document.querySelector('[data-product-form] [type="submit"]') || document.querySelector('[data-bundle-add]');
  var stickyAtc = document.querySelector('.sticky-atc');
  if (mainAtc && stickyAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(mainAtc);
  }

  /* ============================================================
     8. PDP GALLERY THUMBNAILS
     ============================================================ */
  (function () {
    var wrap = document.querySelector('.pdp__main-img');
    var slides = wrap ? wrap.querySelectorAll('.pdp__slide') : [];
    var thumbsWrap = document.querySelector('.pdp__thumbs');
    var thumbs = document.querySelectorAll('.pdp__thumbs button');
    if (!slides.length) return;
    var current = 0;

    function setSlide(i) {
      var n = slides.length;
      current = ((i % n) + n) % n; // wrap around
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', (parseInt(t.getAttribute('data-index'), 10) || 0) === current); });
    }
    window.ErgomiShowSlide = setSlide; // lets the colour picker drive the main image

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.hasAttribute('data-thumb-expand') && thumbsWrap) thumbsWrap.classList.remove('is-collapsed');
        setSlide(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });

    // Prev / next arrow buttons
    var prev = wrap.querySelector('.pdp__nav--prev');
    var next = wrap.querySelector('.pdp__nav--next');
    if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
    if (next) next.addEventListener('click', function () { setSlide(current + 1); });

    // Touch swipe (mobile)
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      // horizontal swipe only (ignore vertical scroll)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        setSlide(current + (dx < 0 ? 1 : -1));
      }
      x0 = null; y0 = null;
    }, { passive: true });
  })();

  /* ============================================================
     9. PDP VARIANT -> price / id / availability / sticky price
     ============================================================ */
  var pdpJson = document.querySelector('[data-product-json]');
  if (pdpJson) {
    var product = null;
    try { product = JSON.parse(pdpJson.textContent); } catch (e) {}
    var pform = document.querySelector('form[data-product-form]');
    if (product && pform) {
      var idField = pform.querySelector('[name="id"]');
      var priceEl = document.querySelector('.pdp__price [data-price]');
      var compareEl = document.querySelector('.pdp__price [data-compare-price]');
      var discountEl = document.querySelector('.pdp__price [data-discount]');
      var stickyPrice = document.querySelector('.sticky-atc__price');
      var submitSpan = pform.querySelector('[type="submit"] span');
      var submitBtn = pform.querySelector('[type="submit"]');
      var update = function () {
        var chosen = [];
        pform.querySelectorAll('.variant-group').forEach(function (g) {
          var sel = g.querySelector('input:checked');
          if (sel) chosen.push(sel.value);
        });
        var match = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        }) || product.variants[0];
        if (!match) return;
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        // Compare-at price + discount badge per variant
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (compareEl) {
          if (onSale) { compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (discountEl) {
          if (onSale) { discountEl.textContent = '−' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; discountEl.hidden = false; }
          else discountEl.hidden = true;
        }
        if (submitSpan) submitSpan.textContent = match.available ? (H.strings.addToCart || 'Lägg i varukorgen') : (H.strings.soldOut || 'Slutsåld');
        if (submitBtn) submitBtn.disabled = !match.available;
      };
      pform.querySelectorAll('.variant-options input').forEach(function (i) {
        i.addEventListener('change', update);
      });
    }
  }

  /* ============================================================
     11. BEFORE / AFTER COMPARE SLIDER (drag: mouse + touch + keyboard)
     ============================================================ */
  document.querySelectorAll('[data-compare]').forEach(function (c) {
    var knob = c.querySelector('[data-compare-knob]');
    var dragging = false;
    function setPos(clientX) {
      var r = c.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      c.style.setProperty('--pos', pct + '%');
      if (knob) knob.setAttribute('aria-valuenow', Math.round(pct));
    }
    if (window.PointerEvent) {
      c.addEventListener('pointerdown', function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
    } else {
      c.addEventListener('mousedown', function (e) { dragging = true; setPos(e.clientX); });
      window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
      window.addEventListener('mouseup', function () { dragging = false; });
      c.addEventListener('touchstart', function (e) { setPos(e.touches[0].clientX); }, { passive: true });
      c.addEventListener('touchmove', function (e) { setPos(e.touches[0].clientX); }, { passive: true });
    }
    if (knob) {
      knob.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(c).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { setVar(Math.max(0, cur - 4)); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setVar(Math.min(100, cur + 4)); e.preventDefault(); }
        function setVar(v) { c.style.setProperty('--pos', v + '%'); knob.setAttribute('aria-valuenow', Math.round(v)); }
      });
    }
  });

  /* ============================================================
     12. STATS COUNT-UP (animate on scroll into view)
     ============================================================ */
  (function () {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    function fmt(v, decimals) {
      try { return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v); }
      catch (e) { return v.toFixed(decimals); }
    }
    function run(el) {
      var raw = el.getAttribute('data-countup') || '';
      var pre = el.getAttribute('data-prefix') || '';
      var suf = el.getAttribute('data-suffix') || '';
      var target = parseFloat(String(raw).replace(',', '.'));
      if (isNaN(target)) { el.textContent = pre + raw + suf; return; }
      var decimals = (String(raw).split('.')[1] || '').length;
      if (reduced) { el.textContent = pre + fmt(target, decimals) + suf; return; }
      var dur = 1300, t0 = null;
      requestAnimationFrame(function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + fmt(target * eased, decimals) + suf;
        if (p < 1) requestAnimationFrame(step);
      });
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  /* ============================================================
     13. PRODUCT REVIEWS — pagination + photo lightbox
     ============================================================ */
  (function () {
    var list = document.querySelector('[data-reviews]');
    var pager = document.querySelector('[data-review-pager]');
    if (list && pager) {
      var cards = Array.prototype.slice.call(list.querySelectorAll('.rv'));
      var perPage = parseInt(list.getAttribute('data-per-page'), 10) || 6;
      var pageCount = Math.ceil(cards.length / perPage);
      var current = 1;
      function pageList(cur) {
        var keep = {}; [1, 2, pageCount - 1, pageCount, cur - 1, cur, cur + 1].forEach(function (n) { if (n >= 1 && n <= pageCount) keep[n] = 1; });
        var nums = Object.keys(keep).map(Number).sort(function (a, b) { return a - b; });
        var out = [], prev = 0;
        nums.forEach(function (n) { if (prev && n - prev > 1) out.push('…'); out.push(n); prev = n; });
        return out;
      }
      function renderPager() {
        var html = '<button type="button" data-nav="prev" aria-label="' + (H.strings.previous || 'Föregående') + '"' + (current === 1 ? ' disabled' : '') + '>‹</button>';
        pageList(current).forEach(function (n) {
          if (n === '…') html += '<span class="rvp-dots">…</span>';
          else html += '<button type="button" data-page="' + n + '"' + (n === current ? ' class="is-active"' : '') + '>' + n + '</button>';
        });
        html += '<button type="button" data-nav="next" aria-label="' + (H.strings.next || 'Nästa') + '"' + (current === pageCount ? ' disabled' : '') + '>›</button>';
        pager.innerHTML = html;
      }
      function showPage(page) {
        current = Math.max(1, Math.min(pageCount, page));
        cards.forEach(function (c, i) {
          c.style.display = (i >= (current - 1) * perPage && i < current * perPage) ? '' : 'none';
        });
        renderPager();
      }
      pager.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || b.disabled) return;
        var nav = b.getAttribute('data-nav');
        if (nav === 'prev') showPage(current - 1);
        else if (nav === 'next') showPage(current + 1);
        else if (b.getAttribute('data-page')) showPage(parseInt(b.getAttribute('data-page'), 10));
        var anchor = document.getElementById('omdomen');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      showPage(1);
    }

    // Photo lightbox (delegated; works across pages)
    var lb = document.querySelector('[data-rv-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-rv-img]');
      function closeLb() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); updateScrollLock(); }
      document.addEventListener('click', function (e) {
        var ph = e.target.closest('.rv__photo');
        if (ph) {
          var full = ph.getAttribute('data-full');
          if (full && lbImg) { lbImg.src = full; lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
          return;
        }
        if (e.target.closest('[data-rv-close]')) closeLb();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb(); });
    }
  })();

  /* ============================================================
     14. COLLECTION FILTER & SORT DRAWER
     ============================================================ */
  (function () {
    var drawer = document.querySelector('.filter-drawer');
    if (!drawer) return;
    function openD() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); updateScrollLock(); }
    function closeD() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); updateScrollLock(); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openD(); return; }
      if (e.target.closest('[data-filter-close]')) { closeD(); return; }
      var head = e.target.closest('.filter-group__head');
      if (head) {
        var exp = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', String(!exp));
        var body = head.nextElementSibling;
        if (body) body.hidden = exp;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeD(); });

    var form = drawer.querySelector('[data-filter-form]');
    var instock = drawer.querySelector('[data-instock-toggle]');
    var applyCount = drawer.querySelector('[data-apply-count]');
    function updateApplyCount() {
      if (!applyCount) return;
      var n = form ? form.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked').length : 0;
      if (instock && instock.checked) n += 1;
      applyCount.textContent = n;
    }
    if (instock) {
      instock.addEventListener('change', function () {
        document.body.classList.toggle('hide-soldout', instock.checked);
        updateApplyCount();
      });
    }
    if (form) form.addEventListener('change', updateApplyCount);
    updateApplyCount();
  })();

  /* ============================================================
     15. BUNDLE — buy more, save more (per-pair colour + size)
     ============================================================ */
  (function () {
    var bundle = document.querySelector('[data-bundle]');
    if (!bundle) return;
    var product = null;
    var pj = document.querySelector('[data-product-json]');
    try { product = JSON.parse(pj.textContent); } catch (e) {}
    if (!product || !product.variants) return;
    var colorPos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;
    var sizePos = parseInt(bundle.getAttribute('data-size-pos'), 10) || 0;
    var saveEl = bundle.querySelector('[data-bundle-save]');
    var addBtn = bundle.querySelector('[data-bundle-add]');
    var qty = 1;

    /* ---- Colour -> image maps + build the dropdowns (shared helpers) ---- */
    var maps = colourImageMaps(product, colorPos);
    var colorImg = maps.img, colorImgPos = maps.pos;
    Array.prototype.forEach.call(bundle.querySelectorAll('.bundle__select'), function (sel) { buildCustomSelect(sel, colorImg); });

    /* ---- Tiers: reveal the chosen tier's pair pickers right below it ---- */
    function selectTier(input) {
      qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
      Array.prototype.forEach.call(bundle.querySelectorAll('.bundle__group'), function (g) {
        var sel = g.contains(input);
        g.classList.toggle('is-selected', sel);
        var pk = g.querySelector('[data-picks]');
        if (pk) pk.hidden = !sel;
      });
      // query fresh each time: addToCart restores the button's HTML afterwards,
      // which replaces the span node and would orphan a cached reference
      var totalNow = bundle.querySelector('[data-bundle-total]');
      if (totalNow) totalNow.textContent = input.getAttribute('data-total-money') || '';
      // data-price-sync → headline price in the buy box tracks the selected tier
      if (bundle.hasAttribute('data-price-sync')) {
        var headline = document.querySelector('.pdp__price [data-price]');
        if (headline) headline.textContent = input.getAttribute('data-total-money') || '';
      }
      // Keep the sticky mobile bar in sync with the selected bundle price
      // (short "499 kr" format when provided; formal money format as fallback)
      var stickyPrice = document.querySelector('.sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = input.getAttribute('data-total-short') || input.getAttribute('data-total-money') || '';
      var save = input.getAttribute('data-save-money');
      if (saveEl) {
        if (save && qty > 1) {
          saveEl.textContent = ((H.strings && H.strings.youSave) || 'Du sparar [amount]').replace('[amount]', save);
          saveEl.hidden = false;
          saveEl.classList.remove('is-bump');
          void saveEl.offsetWidth; // restart the micro-animation
          saveEl.classList.add('is-bump');
        } else saveEl.hidden = true;
      }
      var nudge = bundle.querySelector('[data-bundle-nudge]');
      if (nudge) nudge.hidden = qty !== 2;
    }
    /* ---- Segmenterat färgval (en väljare per order: Svart / Vit / Mix) ---- */
    bundle.addEventListener('click', function (e) {
      var segBtn = e.target.closest('.bundle__seg-btn');
      if (!segBtn) return;
      var segWrap = segBtn.closest('[data-color-seg]');
      if (!segWrap) return;
      Array.prototype.forEach.call(segWrap.querySelectorAll('.bundle__seg-btn'), function (b) {
        var on = b === segBtn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var note = segWrap.parentElement.querySelector('[data-mix-note]');
      if (note) note.hidden = segBtn.getAttribute('data-color-choice') !== 'mix';
    });

    bundle.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      if (e.target.matches('input[type=radio][data-qty]')) { selectTier(e.target); return; }
      if (e.target.matches('select[data-bundle-color]')) {
        // data-color-swap="off" → colour picks are free-standing (no gallery jump/swap)
        if (bundle.getAttribute('data-color-swap') === 'off') return;
        var pos = colorImgPos[e.target.value];
        if (pos && window.ErgomiShowSlide) {
          window.ErgomiShowSlide(pos - 1);
          var g = document.querySelector('.pdp__gallery') || document.querySelector('.pdp__main-img');
          if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
    var checked = bundle.querySelector('input[data-qty]:checked') || bundle.querySelector('input[data-qty]');
    if (checked) { checked.checked = true; selectTier(checked); }

    // Micro-upsell: nudge under the ATC button selects the family tier (5-pack)
    var nudgeBtn = bundle.querySelector('[data-bundle-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () {
      var fam = bundle.querySelector('input[data-qty="5"]') || bundle.querySelector('input[data-qty="4"]');
      if (fam) { fam.checked = true; selectTier(fam); }
    });

    // After addToCart restores the button HTML ("Tillagd" → original), re-sync the
    // fresh price span to the currently selected tier
    document.addEventListener('ergomi:atcRestored', function () {
      var chk = bundle.querySelector('input[data-qty]:checked');
      if (chk) selectTier(chk);
    });

    function findVariant(color, size) {
      return product.variants.find(function (vr) {
        var ok = true;
        if (colorPos) ok = ok && vr.options[colorPos - 1] === color;
        if (sizePos) ok = ok && vr.options[sizePos - 1] === size;
        return ok;
      });
    }
    if (addBtn) addBtn.addEventListener('click', function () {
      var ci = bundle.querySelector('input[data-qty]:checked');
      var group = ci ? ci.closest('.bundle__group') : null;

      // Segment path: one colour choice per order. Pure colours map to the matching
      // colour variant; Mix splits into REAL variant lines (e.g. 1× Svart + 1× Vit)
      // so the cart shows exactly what ships. Only if the product lacks colour
      // variants: one line on the default variant with a "Färg" property instead.
      var seg = group ? group.querySelector('[data-color-seg]') : null;
      if (seg) {
        var active = seg.querySelector('.bundle__seg-btn.is-active');
        var choice = active ? active.getAttribute('data-color-choice') : '';
        var propVal = active ? active.getAttribute('data-prop') : '';
        var colourVariant = function (name) {
          return product.variants.find(function (vr) {
            var cv = (vr.options[colorPos - 1] || '').toLowerCase();
            return name === 'svart'
              ? (cv.indexOf('svart') > -1 || cv.indexOf('black') > -1)
              : (cv.indexOf('vit') > -1 || cv.indexOf('white') > -1);
          });
        };
        var segItems = [];
        if (colorPos && choice === 'mix') {
          var nB = parseInt(active.getAttribute('data-mix-svart'), 10) || 0;
          var nW = parseInt(active.getAttribute('data-mix-vit'), 10) || 0;
          var vB = colourVariant('svart'), vW = colourVariant('vit');
          if (vB && vW && nB > 0 && nW > 0) {
            segItems = [{ id: vB.id, quantity: nB }, { id: vW.id, quantity: nW }];
          }
        } else if (colorPos && (choice === 'svart' || choice === 'vit')) {
          var vc = colourVariant(choice);
          if (vc) segItems = [{ id: vc.id, quantity: qty }];
        }
        if (!segItems.length) {
          var fb = product.variants.find(function (vr) { return vr.available !== false; }) || product.variants[0];
          if (!fb) return;
          var one = { id: fb.id, quantity: qty };
          if (propVal) { one.properties = {}; one.properties[H.strings.colorProp || 'Färg'] = propVal; }
          segItems = [one];
        }
        addToCart(segItems, addBtn, { showUpsell: true });
        return;
      }

      var items = [], missing = false;
      var rows = group ? Array.prototype.slice.call(group.querySelectorAll('.bundle__pick')) : [];
      if (!rows.length) {
        items.push({ id: product.variants[0].id, quantity: qty });
      } else {
        rows.forEach(function (row) {
          var c = row.querySelector('[data-bundle-color]');
          var s = row.querySelector('[data-bundle-size]');
          var variant = findVariant(c ? c.value : null, s ? s.value : null);
          if (variant && variant.available !== false) items.push({ id: variant.id, quantity: 1 });
          else missing = true;
        });
      }
      if (missing || !items.length) { alert(H.strings.comboUnavailable || 'Den kombinationen finns inte i lager just nu — välj en annan färg eller storlek.'); return; }
      var merged = {};
      items.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + it.quantity; });
      var finalItems = Object.keys(merged).map(function (id) { return { id: parseInt(id, 10), quantity: merged[id] }; });
      addToCart(finalItems, addBtn, { showUpsell: true });
    });
  })();

  /* ============================================================
     15b. VARIANT BUNDLE — tick PDP: paketnivåerna är riktiga
         varianter (Antal × Färg). Val av nivå + färg löser ett
         variant-id in i formuläret (quantity alltid 1). Alla
         prissträngar kommer serverformaterade från Liquid via
         [data-vbundle-data] (money-filtret, aktiv marknad) —
         modulen formaterar ALDRIG valuta själv.
     ============================================================ */
  (function () {
    var root = document.querySelector('[data-vbundle]');
    if (!root) return;
    var dataEl = document.querySelector('[data-vbundle-data]');
    if (!dataEl) return;
    var cfg = null;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!cfg || !cfg.variants || !cfg.variants.length) return;
    var V = cfg.variants;

    var state = { antal: '', color: '' };
    var initInput = root.querySelector('input[name="bundle-tier"]:checked') || root.querySelector('input[name="bundle-tier"]');
    if (initInput) state.antal = initInput.getAttribute('data-vb-antal') || '';
    var initSeg = root.querySelector('.bundle__seg-btn.is-active');
    if (initSeg) state.color = initSeg.getAttribute('data-vb-color') || '';

    function findVariant(a, c) {
      for (var i = 0; i < V.length; i++) {
        if ((cfg.antalPos === 0 || V[i].antal === a) && (cfg.colorPos === 0 || V[i].farg === c)) return V[i];
      }
      return null;
    }
    function syncSegs() {
      root.querySelectorAll('[data-color-seg]').forEach(function (seg) {
        var activeMix = false, any = false;
        seg.querySelectorAll('.bundle__seg-btn').forEach(function (b) {
          var on = (b.getAttribute('data-vb-color') || '') === state.color;
          if (on) { any = true; if (b.hasAttribute('data-vb-mix')) activeMix = true; }
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var note = seg.parentElement.querySelector('[data-mix-note]');
        if (note) note.hidden = !(any && activeMix);
      });
    }
    function resolve() {
      var v = findVariant(state.antal, state.color);
      if (!v && cfg.colorPos > 0) {
        // colour missing in this tier (e.g. Mix on 1 st) → tier's first colour
        for (var i = 0; i < V.length; i++) {
          if (cfg.antalPos === 0 || V[i].antal === state.antal) { v = V[i]; state.color = V[i].farg; break; }
        }
        syncSegs();
      }
      return v;
    }
    function apply(animate) {
      var v = resolve();
      if (!v) return;
      var idEl = root.querySelector('[data-vb-id]');
      if (idEl) idEl.value = v.id;
      // ATC button — fresh queries every time: addToCart restores innerHTML,
      // which replaces the price span node
      var btn = root.querySelector('[data-bundle-add]');
      if (btn) {
        var span = btn.querySelector('span');
        if (span) {
          if (v.available === false) {
            btn.disabled = true;
            span.textContent = cfg.soldOut || '';
          } else {
            btn.disabled = false;
            var totalEl = span.querySelector('[data-vb-total]');
            if (!totalEl) {
              span.innerHTML = (cfg.addToCart || '') + ' · <span data-vb-total></span>';
              totalEl = span.querySelector('[data-vb-total]');
            }
            if (totalEl) totalEl.textContent = v.price;
          }
        }
      }
      // Rubrikpriset är medvetet ORÖRT här — det visar alltid 1 st-priset
      // (serverrenderat) som konsekvent ankare oavsett valt paket.
      var gBadge = document.querySelector('[data-vb-gallery-pct]');
      if (gBadge) { gBadge.hidden = !v.pct; if (v.pct) gBadge.textContent = '−' + v.pct + '%'; }
      // Sticky-barens pris är medvetet ORÖRT här — det visar alltid 1 st-priset
      // (serverrenderat), precis som rubrikpriset.
      var saveEl = root.querySelector('[data-bundle-save]');
      if (saveEl) {
        if (v.save) {
          saveEl.textContent = v.save;
          saveEl.hidden = false;
          if (animate) { saveEl.classList.remove('is-bump'); void saveEl.offsetWidth; saveEl.classList.add('is-bump'); }
        } else saveEl.hidden = true;
      }
      var nudge = root.querySelector('[data-bundle-nudge]');
      if (nudge) {
        var ci = root.querySelector('input[name="bundle-tier"]:checked');
        var units = ci ? (parseInt(ci.getAttribute('data-vb-units'), 10) || 0) : 0;
        nudge.hidden = units !== 2;
      }
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[name="bundle-tier"]')) return;
      state.antal = e.target.getAttribute('data-vb-antal') || '';
      root.querySelectorAll('.bundle__group').forEach(function (g) {
        var sel = g.contains(e.target);
        g.classList.toggle('is-selected', sel);
        var pk = g.querySelector('[data-picks]');
        if (pk) pk.hidden = !sel;
      });
      syncSegs();
      apply(true);
    });
    root.addEventListener('click', function (e) {
      var segBtn = e.target.closest('.bundle__seg-btn');
      if (!segBtn) return;
      state.color = segBtn.getAttribute('data-vb-color') || '';
      syncSegs();
      apply(true);
    });
    var nudgeBtn = root.querySelector('[data-bundle-nudge]');
    if (nudgeBtn) nudgeBtn.addEventListener('click', function () {
      var target = nudgeBtn.getAttribute('data-vb-goto') || '';
      var hit = null;
      root.querySelectorAll('input[name="bundle-tier"]').forEach(function (i) {
        if (i.getAttribute('data-vb-antal') === target) hit = i;
      });
      if (hit) { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    // addToCart restores the button's original HTML after "Tillagd" — re-sync
    document.addEventListener('ergomi:atcRestored', function () { apply(false); });
    apply(false);
  })();

  /* ============================================================
     16. STANDARD PRODUCT PAGE — colour/size dropdowns + image swap
         (same custom selects as the multi-buy bundle, single ATC)
     ============================================================ */
  (function () {
    var form = document.querySelector('[data-variant-form]');
    if (!form) return;
    var product = null;
    var pj = document.querySelector('[data-product-json]');
    try { product = JSON.parse(pj.textContent); } catch (e) {}
    if (!product || !product.variants) return;

    var selects = form.querySelectorAll('select[data-variant-option]');
    if (!selects.length) return;
    var colorSel = form.querySelector('select[data-variant-color]');
    var colorPos = colorSel ? (parseInt(colorSel.getAttribute('data-position'), 10) || 0) : 0;
    var maps = colourImageMaps(product, colorPos);
    Array.prototype.forEach.call(selects, function (sel) { buildCustomSelect(sel, maps.img); });

    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('.pdp__price [data-price]');
    var compareEl = document.querySelector('.pdp__price [data-compare-price]');
    var discountEl = document.querySelector('.pdp__price [data-discount]');
    var submitBtn = form.querySelector('[type="submit"]');
    var submitSpan = submitBtn ? submitBtn.querySelector('span') : null;
    var stickyPrice = document.querySelector('.sticky-atc__price');

    function chosen() {
      var arr = [];
      Array.prototype.forEach.call(selects, function (s) {
        arr[(parseInt(s.getAttribute('data-position'), 10) || 1) - 1] = s.value;
      });
      return arr;
    }
    function update() {
      var ch = chosen();
      var match = product.variants.find(function (vr) {
        return vr.options.every(function (o, i) { return ch[i] == null || o === ch[i]; });
      }) || product.variants[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) {
        if (onSale) { compareEl.textContent = money(match.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (discountEl) {
        if (onSale) { discountEl.textContent = '−' + Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100) + '%'; discountEl.hidden = false; }
        else discountEl.hidden = true;
      }
      if (submitSpan) submitSpan.textContent = match.available ? (H.strings.addToCart || 'Lägg i varukorgen') : (H.strings.soldOut || 'Slutsåld');
      if (submitBtn) submitBtn.disabled = !match.available;
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('select[data-variant-option]')) return;
      update();
      if (e.target.matches('[data-variant-color]')) {
        var pos = maps.pos[e.target.value];
        if (pos && window.ErgomiShowSlide) window.ErgomiShowSlide(pos - 1);
      }
    });
    update();
  })();

  /* ============================================================
     17. ANIMATED HEADLINE — reveal (device-agnostic, no GSAP needed)
     ============================================================ */
  (function () {
    var heads = document.querySelectorAll('.animate-headline');
    if (!heads.length) return;
    if (reduced) { heads.forEach(function (h) { h.classList.add('is-in'); }); return; }
    // Stagger each line's reveal via transition-delay, then flip .is-in
    heads.forEach(function (h) {
      var lines = h.querySelectorAll('.line > span');
      lines.forEach(function (s, i) { s.style.transitionDelay = (i * 90 + 80) + 'ms'; });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { h.classList.add('is-in'); });
      });
    });
  })();

  /* ============================================================
     18. QUANTITY STEPPER (PDP)
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-stepper button');
    if (!btn) return;
    var wrap = btn.closest('.qty-stepper');
    var input = wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     19. HORIZONTAL CAROUSEL NAV (prev / next scroll)
     ============================================================ */
  document.querySelectorAll('.p-carousel').forEach(function (car) {
    var track = car.querySelector('.p-carousel__track');
    if (!track) return;
    car.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.hasAttribute('data-carousel-next') ? 1 : -1;
        var first = track.firstElementChild;
        var step = first ? (first.getBoundingClientRect().width + 20) : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      });
    });
  });

  /* ============================================================
     20. HEADER SEARCH — animated typing placeholder + suggestions
         (popular searches on focus, live product results via
         Shopify predictive search while typing)
     ============================================================ */
  (function () {
    var form = document.querySelector('form[data-search]');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    var panel = form.querySelector('[data-search-panel]');
    var popularEl = form.querySelector('[data-search-popular]');
    var resultsEl = form.querySelector('[data-search-results]');
    if (!input) return;

    var terms = (form.getAttribute('data-popular') || '').split(',')
      .map(function (t) { return t.trim(); }).filter(Boolean);
    var defaultPh = input.getAttribute('placeholder') || '';
    var suggestBase = (form.getAttribute('data-suggest-url') || '/search/suggest') + '.json';
    var searchUrl = form.getAttribute('action') || '/search';

    /* ---- Typing effect: types a popular term, pauses, backspaces, next ---- */
    var typing = { word: 0, chr: 0, deleting: false, timer: null, active: false };
    function typeTick() {
      if (!typing.active) return;
      var word = terms[typing.word % terms.length];
      var delay;
      if (!typing.deleting) {
        typing.chr++;
        input.setAttribute('placeholder', word.slice(0, typing.chr));
        if (typing.chr >= word.length) { typing.deleting = true; delay = 1600; }
        else delay = 65 + Math.random() * 70;
      } else {
        typing.chr--;
        input.setAttribute('placeholder', word.slice(0, typing.chr));
        if (typing.chr <= 0) { typing.deleting = false; typing.word++; delay = 500; }
        else delay = 32;
      }
      typing.timer = setTimeout(typeTick, delay);
    }
    function startTyping() {
      if (reduced || !terms.length || typing.active) return;
      if (input.value || document.activeElement === input) return;
      typing.active = true; typing.chr = 0; typing.deleting = false;
      typing.timer = setTimeout(typeTick, 600);
    }
    function stopTyping(restoreDefault) {
      typing.active = false;
      if (typing.timer) clearTimeout(typing.timer);
      if (restoreDefault) input.setAttribute('placeholder', defaultPh);
    }
    startTyping();

    /* ---- Suggestions panel ---- */
    function openPanel() { if (panel) { panel.hidden = false; } }
    function closePanel() { if (panel) { panel.hidden = true; } }
    function showPopular() {
      if (popularEl) popularEl.style.display = '';
      if (resultsEl) { resultsEl.style.display = 'none'; resultsEl.innerHTML = ''; }
    }
    function showResults(html) {
      if (popularEl) popularEl.style.display = 'none';
      if (resultsEl) { resultsEl.style.display = ''; resultsEl.innerHTML = html; }
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var debounce = null, lastQ = '', reqSeq = 0;
    function fetchSuggestions(q) {
      var seq = ++reqSeq;
      var url = suggestBase + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== reqSeq || input.value.trim() !== q) return; // stale response
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var html = '';
          if (products.length) {
            html += '<p class="search-panel__label">Produkter</p>';
            products.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=92';
              var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
              html += '<a class="search-panel__prod" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" width="46" height="46" loading="lazy">' : '<span></span>') +
                '<b>' + esc(p.title) + '</b><span>' + price + '</span></a>';
            });
          } else {
            html += '<p class="search-panel__empty">' + (H.strings.searchEmpty || 'Inga träffar på “[q]” — prova ett annat ord.').replace('[q]', esc(q)) + '</p>';
          }
          html += '<a class="search-panel__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '">' +
            (H.strings.searchAll || 'Visa alla resultat för “[q]”').replace('[q]', esc(q)) + '</a>';
          showResults(html);
          openPanel();
        })
        .catch(function () { /* predictive search unavailable → keep popular terms */ });
    }

    function onFocusOpen() {
      stopTyping(true);
      if (input.value.trim().length >= 2) fetchSuggestions(input.value.trim());
      else showPopular();
      openPanel();
    }
    input.addEventListener('focus', onFocusOpen);
    input.addEventListener('click', function () { if (panel && panel.hidden) onFocusOpen(); });
    input.addEventListener('blur', function () {
      // panel closes via outside-click; just resume the typing animation when left empty
      setTimeout(function () { if (!input.value) startTyping(); }, 300);
    });
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounce) clearTimeout(debounce);
      if (q.length < 2) { showPopular(); openPanel(); return; }
      debounce = setTimeout(function () {
        if (q === lastQ) return;
        lastQ = q;
        fetchSuggestions(q);
      }, 200);
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closePanel();
      var term = e.target.closest('[data-search-term]');
      if (term && form.contains(term)) {
        input.value = term.getAttribute('data-search-term');
        form.submit();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); input.blur(); }
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
  })();

  /* ============================================================
     21. INTERAKTIV FÄSTINGDEMO (hem + PDP) — responsiv scen.
         viewBox följer containerns proportioner så inget beskärs
         på mobil; enhet, ringar, glöd och skyddszon centreras och
         skalas om vid resize. Delad av startsidan och clip-PDP:n.
     ============================================================ */
  document.querySelectorAll('[data-tick-demo]').forEach(function (demo) {
    var stage = demo.querySelector('[data-demo-stage]');
    var layer = demo.querySelector('[data-demo-ticks]');
    var toggle = demo.querySelector('[data-demo-toggle]');
    var statusText = demo.querySelector('[data-demo-status-text]');
    if (!stage || !layer || !toggle) return;
    var NS = 'http://www.w3.org/2000/svg';
    var device = demo.querySelector('[data-demo-device]');
    var rings = demo.querySelectorAll('[data-demo-rings] circle');
    var glow = demo.querySelector('[data-demo-glow]');
    var zone = demo.querySelector('[data-demo-zone]');
    var H = 440, W = 800, CX = 400, CY = 220, DS = 1, N = 7;
    var on = false, ticks = [];

    function layout() {
      var r = stage.getBoundingClientRect();
      if (!r.width || !r.height) return;
      W = Math.max(340, Math.round(H * (r.width / r.height)));
      stage.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      CX = W / 2; CY = H / 2;
      DS = Math.max(0.9, Math.min(1.2, W / 720));
      if (device) device.setAttribute('transform', 'translate(' + CX + ' ' + CY + ') scale(' + DS + ')');
      rings.forEach(function (c) { c.setAttribute('cx', CX); c.setAttribute('cy', CY); });
      if (glow) { glow.setAttribute('cx', CX); glow.setAttribute('cy', CY); glow.setAttribute('r', Math.round(Math.min(W, H) * 0.48)); }
      if (zone) { zone.setAttribute('cx', CX); zone.setAttribute('cy', CY); zone.setAttribute('r', Math.round(Math.min(W, H) * 0.33)); }
    }

    function makeTick(scale) {
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('class', 'eh-tick');
      var legs = document.createElementNS(NS, 'g');
      for (var s = -1; s <= 1; s += 2) {
        for (var i = 0; i < 4; i++) {
          var l = document.createElementNS(NS, 'line');
          var a = -0.9 + i * 0.6;
          l.setAttribute('x1', 0); l.setAttribute('y1', 0);
          l.setAttribute('x2', (Math.cos(a) * 11).toFixed(1));
          l.setAttribute('y2', (s * (4 + Math.abs(Math.sin(a)) * 8)).toFixed(1));
          legs.appendChild(l);
        }
      }
      var body = document.createElementNS(NS, 'ellipse');
      body.setAttribute('rx', 7.5); body.setAttribute('ry', 5.5);
      var head = document.createElementNS(NS, 'circle');
      head.setAttribute('cx', 8.5); head.setAttribute('cy', 0); head.setAttribute('r', 3);
      g.appendChild(legs); g.appendChild(body); g.appendChild(head);
      layer.appendChild(g);
      return g;
    }
    function edgePoint() {
      var side = Math.floor(Math.random() * 4);
      if (side === 0) return { x: -30, y: Math.random() * H };
      if (side === 1) return { x: W + 30, y: Math.random() * H };
      if (side === 2) return { x: Math.random() * W, y: -30 };
      return { x: Math.random() * W, y: H + 30 };
    }
    layout();
    for (var i = 0; i < N; i++) {
      var p = edgePoint();
      var sc = 0.8 + Math.random() * 0.7;
      ticks.push({ el: makeTick(sc), x: p.x, y: p.y, scale: sc,
        phase: Math.random() * Math.PI * 2, speed: 0.35 + Math.random() * 0.25,
        jx: (Math.random() - 0.5) * 90, jy: (Math.random() - 0.5) * 70, fled: false });
    }

    function step(t) {
      // Enheten svävar mjukt — liten vertikal bob ovanpå centreringen
      if (device) device.setAttribute('transform',
        'translate(' + CX + ' ' + (CY + Math.sin(t * 0.02) * 3).toFixed(1) + ') scale(' + DS + ')');
      ticks.forEach(function (tk) {
        var txp, typ, sp;
        if (on) {
          var dx0 = tk.x - CX, dy0 = tk.y - CY;
          var d0 = Math.max(1, Math.hypot(dx0, dy0));
          txp = tk.x + (dx0 / d0) * 200; typ = tk.y + (dy0 / d0) * 200;
          sp = tk.speed * 6.5;
          if (tk.x < -40 || tk.x > W + 40 || tk.y < -40 || tk.y > H + 40) { tk.fled = true; tk.el.style.opacity = 0; return; }
        } else {
          txp = CX + tk.jx; typ = CY + tk.jy; sp = tk.speed;
          if (tk.fled) { var np = edgePoint(); tk.x = np.x; tk.y = np.y; tk.fled = false; tk.el.style.opacity = 1; }
        }
        var dx = txp - tk.x, dy = typ - tk.y;
        var d = Math.hypot(dx, dy);
        if (d > (on ? 2 : 62)) {
          tk.x += (dx / d) * sp; tk.y += (dy / d) * sp;
        } else if (!on) {
          var ang = Math.atan2(tk.y - CY, tk.x - CX) + 0.008 * tk.speed * 4;
          var r = Math.max(58, Math.hypot(tk.jx, tk.jy));
          tk.x = CX + Math.cos(ang) * r; tk.y = CY + Math.sin(ang) * r;
        }
        var wob = Math.sin(t * 0.02 * (1 + tk.speed) + tk.phase) * 1.6;
        var rot = Math.atan2(dy, dx) * 180 / Math.PI + (on ? 0 : wob * 3);
        tk.el.setAttribute('transform',
          'translate(' + (tk.x + wob).toFixed(1) + ' ' + tk.y.toFixed(1) + ') rotate(' + rot.toFixed(1) + ') scale(' + tk.scale + ')');
      });
    }

    var raf = null, running = false, tGlobal = 0;
    function frame() { tGlobal += 1; step(tGlobal); raf = requestAnimationFrame(frame); }
    function start() { if (!running && !reduced) { running = true; frame(); } }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); }
    function setOn(state) {
      on = state;
      demo.classList.toggle('is-on', on);
      if (on) demo.classList.add('was-on');
      toggle.setAttribute('aria-pressed', String(on));
      if (statusText) statusText.textContent = on ? (demo.getAttribute('data-on-text') || '') : (demo.getAttribute('data-off-text') || '');
    }
    toggle.addEventListener('click', function () { setOn(!on); });

    var rsz = null;
    window.addEventListener('resize', function () {
      if (rsz) clearTimeout(rsz);
      rsz = setTimeout(layout, 150);
    });

    if (reduced) {
      layout();
      setOn(true);
      ticks.forEach(function (tk, i) {
        var ang = (i / N) * Math.PI * 2;
        tk.el.setAttribute('transform', 'translate(' + (CX + Math.cos(ang) * W * 0.38) + ' ' + (CY + Math.sin(ang) * H * 0.36) + ') rotate(' + (ang * 180 / Math.PI) + ') scale(' + tk.scale + ')');
      });
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { layout(); start(); } else stop(); });
      }, { threshold: 0.05 }).observe(demo);
    } else start();
  });

  /* ---- Initial cart bubble sync ---- */
  fetchCart();
})();
